!(function (t) {
    var e = {};
    function i(n) {
        if (e[n]) return e[n].exports;
        var o = (e[n] = { i: n, l: !1, exports: {} });
        return t[n].call(o.exports, o, o.exports, i), (o.l = !0), o.exports;
    } 
    (i.m = t),
        (i.c = e),
        (i.d = function (t, e, n) {
            i.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: n });
        }),
        (i.r = function (t) {
            "undefined" != typeof Symbol &&
                Symbol.toStringTag &&
                Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }),
                Object.defineProperty(t, "__esModule", { value: !0 });
        }),
        (i.t = function (t, e) {
            if ((1 & e && (t = i(t)), 8 & e)) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var n = Object.create(null);
            if (
                (i.r(n),
                Object.defineProperty(n, "default", { enumerable: !0, value: t }),
                2 & e && "string" != typeof t)
            )
                for (var o in t)
                    i.d(
                        n,
                        o,
                        function (e) {
                            return t[e];
                        }.bind(null, o)
                    );
            return n;
        }),
        (i.n = function (t) {
            var e =
                t && t.__esModule
                    ? function () {
                          return t.default;
                      }
                    : function () {
                          return t;
                      };
            return i.d(e, "a", e), e;
        }),
        (i.o = function (t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }),
        (i.p = ""),
        i((i.s = 25));
})({
    25: function (t, e, i) {
        t.exports = i(26);
    },
    26: function (t, e) {
        (sectionProduct = (function () {
            var t = "[data-add-to-cart]",
                e = "[data-add-to-cart-text]",
                n = "[data-product-featured-image]",
                o = "[data-product-json]",
                s = ".swym-add-to-wishlist";
            function a(t) {
                (this.$container = $(t)),
                    this.$container.attr("data-section-id"),
                    (this.settings = {}),
                    (this.namespace = ".product"),
                    $(o, this.$container).html() &&
                        ((this.productSingleObject = JSON.parse($(o, this.$container).html())),
                        (this.settings.imageSize = slate.Image.imageSize($(n, this.$container).attr("src"))),
                        $("[data-product-single-thumbnail]", this.$container).on(
                            "click",
                            this.updateProductImageFromThumb.bind(this)
                        ),
                        slate.Image.preload(this.productSingleObject.images, this.settings.imageSize),
                        this.initVariants(),
                        this.runSizeUpdates(),
                        this.variantDropdowns(),
                        this.productVariantCheck(),
                        this.checkProductWishlist(),
                        (this.mql = window.matchMedia("(max-width: 1024px)")),
                        this.productImageSlider(),
                        this.completeTheLookSlider(),
                        this.asSeenOnYouSlider());
            }
            return (
                (a.prototype = $.extend({}, a.prototype, {
                    productImageSlider: function () {
                        $("[data-product-single-thumbnail]").each(function (t, e) {
                            $(this).on("click", function () {
                                $(".product-image-slideshow").slick("slickGoTo", t);
                            });
                        }),
                            $(".product-image-slideshow").slick({
                                autoplay: !1,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                infinite: !0,
                                arrows: !0,
                                dots: !!this.mql.matches,
                                asNavFor: ".thumbnail-slider",
                                prevArrow: '<i class="icon-chevron-left"></i>',
                                nextArrow: '<i class="icon-chevron-right"></i>',
                                swipe: !0,
                            }),
                            $(".product-image-slideshow .slick-arrow").on("click", function (t) {
                                t.preventDefault(), t.stopPropagation();
                            }),
                            $(".thumbnail-slider").slick({
                                vertical: !0,
                                verticalSwiping: !0,
                                dots: !1,
                                infinite: !1,
                                speed: 300,
                                prevArrow: '<i class="icon-chevron-up is-block"></i>',
                                nextArrow: '<i class="icon-chevron-down is-block"></i>',
                                slidesToShow: 4,
                            }),
                            $(".thumbnail-slider .slick-slide").on("click", function () {
                                $(".thumbnail-slider .slick-slide").not($(this)).removeClass("slick-current"),
                                    $(this).addClass("slick-current");
                            });
                    },
                    completeTheLookSlider: function () {
                        const t = document.querySelector(".complete-the-look-slideshow-test");
                        (this.mql.matches && t && !t.classList.contains("mobile-enabled")) ||
                            !t ||
                            ((this.mql.matches || !t || t.classList.contains("desktop-enabled")) &&
                                $(".complete-the-look-slideshow").slick({
                                    autoplay: !1,
                                    slidesToShow: 2,
                                    slidesToScroll: 1,
                                    arrows: !this.mql.matches,
                                    dots: !!this.mql.matches,
                                    prevArrow: '<i class="icon-chevron-left"></i>',
                                    nextArrow: '<i class="icon-chevron-right"></i>',
                                    swipe: !0,
                                }));
                    },
                    asSeenOnYouSlider: function () {
                        this.mql.matches
                            ? $(".ugc-slideshow-mobile").slick({
                                  autoplay: !1,
                                  slidesToShow: 2,
                                  slidesToScroll: 1,
                                  arrows: !0,
                                  dots: !1,
                                  prevArrow: '<i class="icon-chevron-left" style="margin:auto;"></i>',
                                  nextArrow: '<i class="icon-chevron-right" style="margin:auto;"></i>',
                                  swipe: !0,
                              })
                            : $(".ugc-slideshow").slick({
                                  autoplay: !1,
                                  slidesToShow: 3,
                                  slidesToScroll: 1,
                                  arrows: !0,
                                  dots: !1,
                                  prevArrow: '<i class="icon-chevron-left"></i>',
                                  nextArrow: '<i class="icon-chevron-right"></i>',
                                  swipe: !0,
                              });
                    },
                    initVariants: function () {
                        var t = {
                            $container: this.$container,
                            enableHistoryState: false,
                            singleOptionSelector: '[data-single-option-selector][id^="SingleOptionSelector"]',
                            originalSelectorId: "[data-product-select]",
                            product: this.productSingleObject,
                        };
                        (this.variants = new slate.Variants(t)),
                            this.$container.on("variantChange" + this.namespace, this.updateAddToCartState.bind(this)),
                            this.$container.on(
                                "variantImageChange" + this.namespace,
                                this.updateProductImage.bind(this)
                            ),
                            this.$container.on(
                                "variantPriceChange" + this.namespace,
                                this.updateProductPrices.bind(this)
                            );
                    },
                    runSizeUpdates: function () {
                        if (typeof window.updatesizesus === "function") {
                            window.updatesizesus();
                        }
                    },
                    updateAddToCartState: function (i) {
                        console.log("updating add to cart state", i.variant);
                        var n = i.variant;
                        if (!n)
                            return (
                                $(t, this.$container).prop("disabled", !0),
                                $(s, this.$container).prop("disabled", !0),
                                void $(t, this.$container).closest(".js-btn-container").addClass("is-enabled")
                            );
                        $(t, this.$container).prop("disabled", !1),
                            $(s, this.$container).prop("disabled", !1),
                            $("[data-price-wrapper]", this.$container).removeClass("is-hidden"),
                            $(t, this.$container)
                                .closest(".js-btn-container")
                                .attr("data-variant-id", n.id)
                                .removeClass("is-enabled"),
                            n.available
                                ? ($(t, this.$container).prop("disabled", !1),
                                  $(e, this.$container).html(theme.strings.addToCart),
                                  $(t, this.$container).closest(".js-btn-container").removeClass("is-enabled"))
                                : ($(t, this.$container).prop("disabled", !0),
                                  $(e, this.$container).html(theme.strings.soldOut),
                                  $(t, this.$container).closest(".js-btn-container").addClass("is-enabled"));
                    },
                    updateProductPrices: function (t) {
                        /* var e = t.variant,
                            i = $("[data-compare-price]", this.$container),
                            n = i.add("[data-compare-text]", this.$container);
                        $("[data-product-price]", this.$container).html(
                            slate.Currency.formatMoney(e.price, theme.moneyFormat)
                        ),
                            e.compare_at_price > e.price
                                ? (i.html(slate.Currency.formatMoney(e.compare_at_price, theme.moneyFormat)),
                                  n.removeClass("is-hidden"))
                                : (i.html(""), n.addClass("is-hidden")); */
                    },
                    updateProductImage: function (t) {
                        var e = t.variant,
                            i = slate.Image.getSizedImageUrl(e.featured_image.src, this.settings.imageSize);
                        $(n, this.$container).attr("src", i);
                    },
                    updateProductImageFromThumb: function (t) {
                        t.preventDefault(), $(t.currentTarget).attr("href");
                    },
                    variantDropdowns: function () {
                        $("body").on("change", "[data-option-selector]", function () {
                            var t = $(this).closest(".product-list-item").find(".add-to-cart"),
                                e = $(this).closest(".product-list-item").find(".js-btn-container"),
                                i = $("option:selected", this).data("variant-id");
                            i
                                ? (t.attr("data-variant-id", i), t.prop("disabled", !1), e.removeClass("is-enabled"))
                                : (t.prop("disabled", !0), e.addClass("is-enabled"));
                        });
                    },
                    productVariantCheck: function () {
                        $("body").on("click", ".js-btn-container", function () {
                            $(this).find(".js-error").remove(),
                                $(this).hasClass("is-enabled") &&
                                    ($(this).parents("form").find("select").addClass("has-border-red")                                   
                                );
                        }),
                            $("body").on("change", "[data-single-option-selector]", function () {
                                $(this).removeClass("has-border-red"),
                                    $(this).parents("form").find(".js-error").remove();
                            });
                    },
                    onUnload: function () {
                        this.$container.off(this.namespace);
                    },
                    checkProductWishlist: function () {
                        let t = [],
                            e = parseInt(document.querySelector("[data-cart-submit]").getAttribute("data-productid"));
                        window.SwymCallbacks || (window.SwymCallbacks = []),
                            window.SwymCallbacks.push(function (i) {
                                let n = document.querySelector(".swym-heart");
                                window._swat.fetch(function (i) {
                                    i.length > 0 &&
                                        i.forEach((i) => {
                                            t.push(i.empi), t.includes(e) && n.classList.add("swym-added");
                                        });
                                });
                            });
                    },
                })),
                a
            );
        })()),
            theme.sections.register("product", sectionProduct);
    },
});
